import {ProductModel} from "../Models/ProductModel";
import {OrderProductModel} from "../Models/OrderModel";
import {useGetTva} from "./useGetTva";

export const useCreateOrderWithoutDiscount = (): (p: ProductModel, quantitee: number) => OrderProductModel => {
    const getTva = useGetTva()

    const createOrder = (p: ProductModel, quantitee: number): OrderProductModel => {
        const unitTva = getTva(p.priceTTC, p.product.tva?.rate)
        const unitPriceHT = +((p.priceTTC - unitTva).toFixed(5))
        return {
            name: p.product.name,
            privateName: p.product.privateName,
            nameCategory: p.product.productCategories[0]?.name,
            nameFamily: p.product.productCategories[0]?.productCategoryFamily?.name,
            quantity: quantitee,
            unitPriceHT: unitPriceHT,
            unitPriceTTC: p.priceTTC,
            unitDepositPriceTTC: p.depositPriceTTC,
            tvaRate: p.product.tva?.rate,
            totalPriceHT: unitPriceHT * quantitee,
            totalPriceTTC: +(p.priceTTC * quantitee).toFixed(2),
            totalDepositPriceTTC: p.depositPriceTTC * quantitee,
            totalTva: unitTva * quantitee,
            tvaCode: p.product.tva?.id,
            product: {
                id: p.product.id,
                image: p.product.image,
                categories: p.product.productCategories,
            }
        }
    }

    return (p: ProductModel, quantitee: number): OrderProductModel => {
        const result = createOrder(p, quantitee)

        if (p.product.isMenu && p.eventPdvProducts?.length > 0) {
            result.eventPdvProducts = p.eventPdvProducts.map(extra => {
                const extraAsProduct: ProductModel = {
                    priceTTC: extra.priceTTC ?? 0,
                    depositPriceTTC: 0,
                    product: extra.product,
                    automaticDiscounts: [],
                    stockAvailable: 0,
                    eventPdvProducts: []
                }
                const orderProduct = createOrder(extraAsProduct, quantitee)
                orderProduct.productMenuName = p.product.name
                return orderProduct
            })
            const avgTvaRate = result.eventPdvProducts.reduce((sum, e) => sum + (e.tvaRate ?? 0), 0) / result.eventPdvProducts.length
            result.tvaRate = Math.round(avgTvaRate * 100) / 100
        }

        return result
    }
}
